<script>
import { required } from "vuelidate/lib/validators";
import MultiSelect from "vue-multiselect";

// Custom Components
import UserService from "@/helpers/APIService/user.service";
import errorHandler from "@/helpers/errorHandler";

export default {
  page: {
    title: "RFID Encoder",
  },
  emits: ["submitted", "cancelSubmit"],
  props: {
    currentProps: Object,
  },
  data() {
    return {
      rfid_encoder_form: {
        mqtt_host: null,
        mqtt_port: null,
        com_port: null,
        mqtt_device_id: null,
        mqtt_user: null,
        mqtt_password: null,
        hotel: null,
        is_active: false,
        is_tls_protocol: false,
      },
      hotels: [],
      submitted: false,
      isBtnLoading: false,
      isError: false,
      errorMessage: null,
      comPortOption: [],
    };
  },
  validations: {
    rfid_encoder_form: {
      mqtt_host: {
        required,
      },
      mqtt_port: {
        required,
      },
      com_port: { required },
      mqtt_device_id: {
        required,
      },
      mqtt_user: { required },
      mqtt_password: { required },
    },
  },
  components: {
    MultiSelect,
  },
  mounted() {
    this.setValue();
  },
  methods: {
    // Method is used to handle set value
    setValue() {
      this.hotels = this.currentProps.hotelOptions;
      if (this.currentProps.isEdit) {
        this.rfid_encoder_form.com_port =
          this.currentProps.rfidEncoder.com_port;
        this.rfid_encoder_form.mqtt_host =
          this.currentProps.rfidEncoder.mqtt_host;
        this.rfid_encoder_form.mqtt_port =
          this.currentProps.rfidEncoder.mqtt_port;
        this.rfid_encoder_form.com_port =
          this.currentProps.rfidEncoder.com_port;
        this.rfid_encoder_form.mqtt_user =
          this.currentProps.rfidEncoder.mqtt_user;
        this.rfid_encoder_form.mqtt_password =
          this.currentProps.rfidEncoder.mqtt_password;
        this.rfid_encoder_form.mqtt_device_id =
          this.currentProps.rfidEncoder.mqtt_device_id;
        this.rfid_encoder_form.is_active =
          this.currentProps.rfidEncoder.is_active;
        this.rfid_encoder_form.is_tls_protocol =
          this.currentProps.rfidEncoder.is_tls_protocol;
        if (this.currentProps.rfidEncoder.hotel) {
          this.rfid_encoder_form.hotel = {
            text: this.currentProps.rfidEncoder.hotel.name,
            value: this.currentProps.rfidEncoder.hotel.id,
          };
        }
      }
      // set com port option
      for (let index = 0; index <= 16; index++) {
        this.comPortOption.push(`COM${index}`);
      }
    },
    // Method is used to add and update device model data
    onSubmit() {
      this.submitted = true;
      this.isBtnLoading = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.isBtnLoading = false;
        return;
      } else {
        if (this.rfid_encoder_form.hotel) {
          this.rfid_encoder_form = {
            ...this.rfid_encoder_form,
            hotel: this.rfid_encoder_form.hotel.value,
          };
        }
        if (this.currentProps.isEdit == false) {
          UserService.addRFIDEncoder(this.rfid_encoder_form)
            .then((response) => {
              this.isBtnLoading = false;
              this.submitted = false;
              this.$emit("submitted", { data: response });
              this.isError = false;
            })
            .catch((error) => {
              this.isError = true;
              if (Array.isArray(error.response.data)) {
                error.response.data.map((item) => {
                  this.errorMessage.push(item);
                });
              } else {
                this.errorMessage = error.response.data;
              }
              this.isBtnLoading = false;
              errorHandler(error);
            });
        } else {
          UserService.editRFIDEncoder(
            this.currentProps.rfidEncoderId,
            this.rfid_encoder_form
          )
            .then((response) => {
              this.$emit("submitted", { data: response, isEdit: true });
              this.isBtnLoading = false;
              this.submitted = false;
              this.isError = false;
            })
            .catch((error) => {
              this.isError = true;
              if (Array.isArray(error.response.data)) {
                error.response.data.map((item) => {
                  this.errorMessage.push(item);
                });
              } else {
                this.errorMessage = error.response.data;
              }
              this.isBtnLoading = false;
              errorHandler(error);
            });
        }
      }
    },
  },
};
</script>

<template>
  <div class="container-fluid">
    <div class="col-md-12">
      <h4>{{ currentProps.isEdit ? "Update" : "Add New" }} RFID Encoder</h4>
      <hr />
    </div>
    <b-form @submit.prevent="onSubmit">
      <div class="row">
        <div class="col-sm-6">
          <div class="mb-3">
            <label for="hotel">Hotel </label>
            <MultiSelect
              v-model="rfid_encoder_form.hotel"
              :options="hotels"
              :show-labels="false"
              placeholder="Select Hotel"
              track-by="value"
              label="text"
              name="hotels"
            />
          </div>
        </div>
        <div class="col-sm-6">
          <div class="mb-3">
            <label for="mqtt_host"
              >MQTT Host <span class="text-danger">*</span></label
            >
            <b-form-input
              id="mqtt_host"
              type="text"
              v-model="rfid_encoder_form.mqtt_host"
              autocomplete="off"
              :class="{
                'is-invalid':
                  submitted && $v.rfid_encoder_form.mqtt_host.$error,
              }"
            ></b-form-input>
            <div v-if="submitted" class="invalid-feedback">
              <span v-if="!$v.rfid_encoder_form.mqtt_host.required"
                >MQTT Host is required.</span
              >
            </div>
          </div>
        </div>

        <div class="col-sm-6">
          <div class="mb-3">
            <label for="mqtt_device_id"
              >MQTT Device Id <span class="text-danger me-1">*</span>
            </label>
            <b-form-input
              id="mqtt_device_id"
              type="text"
              v-model="rfid_encoder_form.mqtt_device_id"
              autocomplete="off"
              :class="{
                'is-invalid':
                  submitted && $v.rfid_encoder_form.mqtt_device_id.$error,
              }"
            ></b-form-input>
            <div v-if="submitted" class="invalid-feedback">
              <span v-if="!$v.rfid_encoder_form.mqtt_device_id.required"
                >MQTT Device Id is required.</span
              >
            </div>
          </div>
        </div>
        <div class="col-sm-6">
          <div class="mb-3">
            <label for="mqtt_user"
              >MQTT User <span class="text-danger me-1">*</span>
            </label>
            <b-form-input
              id="mqtt_user"
              type="text"
              v-model="rfid_encoder_form.mqtt_user"
              autocomplete="off"
              :class="{
                'is-invalid':
                  submitted && $v.rfid_encoder_form.mqtt_user.$error,
              }"
            ></b-form-input>
            <div v-if="submitted" class="invalid-feedback">
              <span v-if="!$v.rfid_encoder_form.mqtt_user.required"
                >MQTT User is required.</span
              >
            </div>
          </div>
        </div>
        <div class="col-sm-6">
          <div class="mb-3">
            <label for="mqtt_password"
              >MQTT Password <span class="text-danger me-1">*</span>
            </label>
            <b-form-input
              id="mqtt_password"
              type="text"
              v-model="rfid_encoder_form.mqtt_password"
              autocomplete="off"
              :class="{
                'is-invalid':
                  submitted && $v.rfid_encoder_form.mqtt_password.$error,
              }"
            ></b-form-input>
            <div v-if="submitted" class="invalid-feedback">
              <span v-if="!$v.rfid_encoder_form.mqtt_password.required"
                >Password is required.</span
              >
            </div>
          </div>
        </div>
        <div class="col-md-3 col-sm-6">
          <div class="mb-3">
            <label for="mqtt_port"
              >MQTT Port <span class="text-danger me-1">*</span>
            </label>
            <b-form-input
              id="mqtt_port"
              type="text"
              v-model="rfid_encoder_form.mqtt_port"
              autocomplete="off"
              :class="{
                'is-invalid':
                  submitted && $v.rfid_encoder_form.mqtt_port.$error,
              }"
            ></b-form-input>
            <div v-if="submitted" class="invalid-feedback">
              <span v-if="!$v.rfid_encoder_form.mqtt_port.required"
                >MQTT Port is required.</span
              >
            </div>
          </div>
        </div>
        <div class="col-md-3 col-sm-6">
          <div class="mb-3">
            <label for="com_port"
              >COM Port <span class="text-danger me-1">*</span>
            </label>
            <MultiSelect
              v-model="rfid_encoder_form.com_port"
              :options="comPortOption"
              :show-labels="false"
              placeholder="Select com port"
              name="com_ports"
              :class="{
                'is-invalid': submitted && $v.rfid_encoder_form.com_port.$error,
              }"
            />
            <div v-if="submitted" class="invalid-feedback">
              <span v-if="!$v.rfid_encoder_form.com_port.required"
                >COM Port is required.</span
              >
            </div>
          </div>
        </div>
        <div class="col-sm-3 col-6">
          <div>
            <label for="is_active">Active</label>
            <div class="form-check form-switch my-1" slot="is_tls_protocol">
              <input
                class="form-check-input"
                id="is_active"
                type="checkbox"
                v-model="rfid_encoder_form.is_active"
              />
            </div>
          </div>
        </div>
        <div class="col-sm-3 col-6">
          <div>
            <label for="is_tls_protocol">TLS Protocol</label>
            <div class="form-check form-switch my-1" slot="is_tls_protocol">
              <input
                class="form-check-input"
                id="is_tls_protocol"
                type="checkbox"
                v-model="rfid_encoder_form.is_tls_protocol"
              />
            </div>
          </div>
        </div>

        <b-alert v-if="isError" show variant="danger">
          <ul>
            <li v-for="(error, index) in errorMessage" :key="index">
              {{ index }}: {{ error[0] }}
            </li>
          </ul>
        </b-alert>

        <div class="col-md-12">
          <hr />
          <b-button
            class="float-end ms-2"
            variant="outline-primary"
            type="reset"
            @click="$emit('cancelSubmit')"
            >Cancel</b-button
          >

          <b-button
            class="float-end"
            variant="outline-primary"
            type="button"
            @click="onSubmit"
          >
            <i
              v-if="isBtnLoading"
              class="bx bx-loader bx-spin font-size-16 align-middle me-2"
            ></i>
            {{ currentProps.isEdit ? "Update" : "Save" }}
          </b-button>
        </div>
      </div>
    </b-form>
  </div>
</template>
